export default function Wordmark() {
  return (
    <div className="h-8 w-full mx-auto">
      <div className="w-7/12 h-full mx-auto flex justify-center items-center">
        <img className="h-full" src="/wordmark.png" alt="product" />
      </div>
    </div>
  );
}
